(() => {
  const PRODUCT_PATHS = {
    'Vero Long Distance Interactive AI-Powered Remote Control Device': '/products/vero-long-distance-interactive-ai-powered-remote-control-thrusting-blowjob-machine-teledildonics-device',
    'Umove Mira & Vero Interactive AI-Powered Remote Control Set': '/products/umove-mira-vero-long-distance-relationship-interactive-ai-powered-remote-control-teledildonics-device-sex-toy',
    'Mira Long Distance Interactive AI-Powered Touch-Sense Device': '/products/mira-long-distance-interactive-ai-powered-remote-control-vibrating-dildo-with-advanced-touch-sense-technology-teledildonics-device'
  };

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const getProductPath = (card) => {
    const mediaLink = card.querySelector('.galatea-card__media');
    if (mediaLink) {
      try {
        const url = new URL(mediaLink.href, window.location.origin);
        if (url.pathname.includes('/products/')) return url.pathname;
      } catch (error) {}
    }

    const title = card.querySelector('h3')?.textContent?.trim();
    return PRODUCT_PATHS[title] || '';
  };

  // Robust cart drawer refresh for the three custom homepage product cards.
  // Refreshes the mini-cart section HTML first, then opens the newly-rendered drawer.
  const openCartDrawer = async () => {
    const currentDrawer = document.getElementById('mini-cart');
    if (!currentDrawer) throw new Error('Mini cart drawer not found');

    const wrapper = currentDrawer.closest('[id^="shopify-section-"]');
    const sectionId = wrapper?.id?.replace(/^shopify-section-/, '');

    const cartResponse = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!cartResponse.ok) throw new Error('Unable to load updated cart');
    const cart = await cartResponse.json();

    // Let the theme know the cart changed so header/cart counters stay in sync.
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart, openMiniCart: false }
      })
    );

    // Re-render the exact mini-cart section so the drawer always contains fresh line items.
    if (sectionId) {
      const sectionUrl = new URL(window.location.href);
      sectionUrl.searchParams.set('sections', sectionId);
      sectionUrl.searchParams.set('_cart_refresh', Date.now().toString());

      const sectionResponse = await fetch(sectionUrl.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (sectionResponse.ok) {
        const sections = await sectionResponse.json();
        const html = sections?.[sectionId];

        if (html) {
          const template = document.createElement('template');
          template.innerHTML = html.trim();
          const freshDrawer = template.content.querySelector('#mini-cart');

          if (freshDrawer) {
            currentDrawer.replaceWith(freshDrawer);
          }
        }
      }
    }

    const drawer = document.getElementById('mini-cart');
    if (!drawer) throw new Error('Refreshed mini cart drawer not found');

    // Give the custom element a moment to reconnect/upgrade before opening it.
    await new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

    if (typeof drawer.show === 'function') {
      drawer.show();
    } else if (typeof drawer.open === 'function') {
      drawer.open();
    } else {
      drawer.setAttribute('open', '');
      drawer.setAttribute('aria-hidden', 'false');
    }

    // Final native refresh/open signal for theme-specific counters/recommendations.
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { cart, openMiniCart: true }
      })
    );
  };

  async function enhanceCard(card) {
    if (card.dataset.galateaEnhanced === 'true' || card.dataset.galateaEnhanced === 'loading') return;

    const productPath = getProductPath(card);
    if (!productPath) return;

    card.dataset.galateaEnhanced = 'loading';

    try {
      const response = await fetch(`${productPath}.js`, {
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Product request failed');

      const product = await response.json();
      const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
      if (!variant) throw new Error('No product variant found');

      const compareAt = Number(variant.compare_at_price || 0);
      const price = Number(variant.price || 0);

      if (compareAt > price && !card.querySelector('.galatea-card__save')) {
        const badge = document.createElement('span');
        badge.className = 'galatea-card__save';
        badge.textContent = `SAVE ${money(compareAt - price)}`;
        card.appendChild(badge);
      }

      if (!card.querySelector('.galatea-card__actions')) {
        const actions = document.createElement('div');
        actions.className = 'galatea-card__actions';
        actions.innerHTML = `
          <div class="galatea-card__qty" aria-label="Quantity selector">
            <button type="button" class="galatea-card__qty-btn" data-dir="-1" aria-label="Decrease quantity">−</button>
            <input class="galatea-card__qty-input" type="number" min="1" value="1" inputmode="numeric" aria-label="Quantity">
            <button type="button" class="galatea-card__qty-btn" data-dir="1" aria-label="Increase quantity">+</button>
          </div>
          <button type="button" class="galatea-card__add" ${variant.available ? '' : 'disabled'}>
            ${variant.available ? 'ADD TO CART' : 'SOLD OUT'}
          </button>
        `;
        card.appendChild(actions);

        const qtyInput = actions.querySelector('.galatea-card__qty-input');
        actions.querySelectorAll('.galatea-card__qty-btn').forEach((button) => {
          button.addEventListener('click', () => {
            const current = Math.max(1, Number(qtyInput.value || 1));
            qtyInput.value = Math.max(1, current + Number(button.dataset.dir || 0));
          });
        });

        qtyInput.addEventListener('change', () => {
          qtyInput.value = Math.max(1, Number(qtyInput.value || 1));
        });

        const addButton = actions.querySelector('.galatea-card__add');
        addButton.addEventListener('click', async () => {
          if (!variant.available || addButton.disabled) return;

          const originalLabel = addButton.textContent;
          addButton.disabled = true;
          addButton.textContent = 'ADDING…';

          try {
            const addResponse = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [{
                  id: variant.id,
                  quantity: Math.max(1, Number(qtyInput.value || 1))
                }]
              })
            });

            if (!addResponse.ok) throw new Error('Unable to add item');
            addButton.textContent = 'ADDED';
            await openCartDrawer();
          } catch (error) {
            addButton.textContent = 'TRY AGAIN';
          } finally {
            window.setTimeout(() => {
              addButton.disabled = !variant.available;
              addButton.textContent = originalLabel;
            }, 1400);
          }
        });
      }

      card.dataset.galateaEnhanced = 'true';
    } catch (error) {
      delete card.dataset.galateaEnhanced;
    }
  }

  const initGalateaProductCards = () => {
    document.querySelectorAll('.galatea-product-grid .galatea-card').forEach(enhanceCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGalateaProductCards);
  } else {
    initGalateaProductCards();
  }

  document.addEventListener('shopify:section:load', initGalateaProductCards);
})();

/* Friend-site flowing gallery parity patch. Injected only on the custom Galatea homepage. */
(() => {
  const FLOW_ID = 'galatea-flowing-gallery';
  const STYLE_ID = 'galatea-flowing-gallery-style';
  const ROWS = [
    {
      src: 'https://cdn.shopify.com/s/files/1/0730/0608/8269/files/homepage-flowing-gallery-row-1.webp?v=1789532504',
      alt: 'Scrolling gallery of female doll styles',
      direction: 'left',
      duration: 24
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0730/0608/8269/files/homepage-flowing-gallery-row-2.webp?v=1789532511',
      alt: 'Scrolling gallery of adult toy products',
      direction: 'right',
      duration: 27
    },
    {
      src: 'https://cdn.shopify.com/s/files/1/0730/0608/8269/files/homepage-flowing-gallery-row-3.webp?v=1789532520',
      alt: 'Scrolling gallery of doll and body products',
      direction: 'left',
      duration: 25
    }
  ];

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #${FLOW_ID} {
        --flow-desktop-height: 172px;
        --flow-mobile-height: 112px;
        --flow-row-gap: 47px;
        --flow-strip-gap: 10px;
        width: 100%;
        overflow: hidden;
        box-sizing: border-box;
        padding: 64px 0 20px;
        background: #fff;
      }
      #${FLOW_ID} .galatea-flow__rows {
        display: flex;
        flex-direction: column;
        gap: var(--flow-row-gap);
      }
      #${FLOW_ID} .galatea-flow__row {
        width: 100%;
        overflow: hidden;
      }
      #${FLOW_ID} .galatea-flow__track {
        display: flex;
        width: max-content;
        will-change: transform;
      }
      #${FLOW_ID} .galatea-flow__group {
        display: flex;
        flex: 0 0 auto;
        align-items: center;
        gap: var(--flow-strip-gap);
        padding-right: var(--flow-strip-gap);
      }
      #${FLOW_ID} .galatea-flow__strip {
        display: block;
        flex: 0 0 auto;
        width: auto;
        height: var(--flow-desktop-height);
        max-width: none;
        object-fit: contain;
      }
      #${FLOW_ID} .galatea-flow__row[data-direction="left"] .galatea-flow__track {
        animation: galateaFlowLeft var(--flow-duration) linear infinite;
      }
      #${FLOW_ID} .galatea-flow__row[data-direction="right"] .galatea-flow__track {
        animation: galateaFlowRight var(--flow-duration) linear infinite;
      }
      #${FLOW_ID} .galatea-flow__row:hover .galatea-flow__track {
        animation-play-state: paused;
      }
      @keyframes galateaFlowLeft {
        from { transform: translate3d(0, 0, 0); }
        to { transform: translate3d(-50%, 0, 0); }
      }
      @keyframes galateaFlowRight {
        from { transform: translate3d(-50%, 0, 0); }
        to { transform: translate3d(0, 0, 0); }
      }
      @media screen and (max-width: 749px) {
        #${FLOW_ID} {
          padding: 38px 0 14px;
          --flow-row-gap: 26px;
        }
        #${FLOW_ID} .galatea-flow__strip {
          height: var(--flow-mobile-height);
        }
      }
      @media (prefers-reduced-motion: reduce) {
        #${FLOW_ID} .galatea-flow__track {
          animation-play-state: paused !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const buildGroup = (row, isDuplicate) => {
    const group = document.createElement('div');
    group.className = 'galatea-flow__group';
    if (isDuplicate) group.setAttribute('aria-hidden', 'true');

    for (let i = 0; i < 5; i += 1) {
      const image = document.createElement('img');
      image.className = 'galatea-flow__strip';
      image.src = row.src;
      image.alt = !isDuplicate && i === 0 ? row.alt : '';
      image.loading = i === 0 && !isDuplicate ? 'eager' : 'lazy';
      image.decoding = 'async';
      group.appendChild(image);
    }

    return group;
  };

  const findAnchor = () => {
    return document.querySelector('.galatea-product-grid')?.closest('.shopify-section')
      || document.querySelector('[id^="shopify-section-"][id*="galatea_home"]')
      || document.querySelector('.galatea-home')?.closest('.shopify-section');
  };

  const initFlowingGallery = () => {
    if (document.getElementById(FLOW_ID)) return;

    const anchor = findAnchor();
    if (!anchor) return;

    ensureStyles();

    const wall = document.createElement('section');
    wall.id = FLOW_ID;
    wall.className = 'galatea-flowing-gallery';
    wall.setAttribute('aria-label', 'Product inspiration gallery');

    const rowsWrap = document.createElement('div');
    rowsWrap.className = 'galatea-flow__rows';

    ROWS.forEach((row) => {
      const rowEl = document.createElement('div');
      rowEl.className = 'galatea-flow__row';
      rowEl.dataset.direction = row.direction;
      rowEl.style.setProperty('--flow-duration', `${row.duration}s`);

      const track = document.createElement('div');
      track.className = 'galatea-flow__track';
      track.appendChild(buildGroup(row, false));
      track.appendChild(buildGroup(row, true));
      rowEl.appendChild(track);
      rowsWrap.appendChild(rowEl);
    });

    wall.appendChild(rowsWrap);
    anchor.insertAdjacentElement('afterend', wall);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFlowingGallery);
  } else {
    initFlowingGallery();
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(initFlowingGallery, 0);
  });
})();
